var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents contents--pt _min-h-xlg"},[_c('notification'),_c('list-information')],1)}
var staticRenderFns = []

export { render, staticRenderFns }